module.exports = __webpack_public_path__ + "static/img/face5.d241728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face5.jpg
// module id = PsGU
// module chunks = 1